


































import Vue from 'vue';
import { BDropdown, BDropdownItemButton, BButton } from 'bootstrap-vue';
import { MetricOptions } from '@/constants/DashboardConstants';

const sortByLabel = (a, b) => a.singular.localeCompare(b.singular);

export default Vue.extend({
  name: 'SurveyAnswerMappingItems',
  components: {
    BDropdown,
    BDropdownItemButton,
    BButton,
  },
  props: {
    surveyResponseId: {
      type: String,
      required: true,
    },
    surveyAnswerId: {
      type: Number,
      required: true,
    },
    mappings: {
      type: Array,
      default: () => [],
    },
    csrf: {
      type: String,
      required: true,
    },
  },
  computed: {
    objectTypes() {
      let currentMetrics = [];
      currentMetrics = Object.values(MetricOptions)
        .map(v => ({ model: v.model, singular: v.label, plural: v.plural }))
        .sort(sortByLabel);
      return currentMetrics.filter(
        i => i.model !== 'SurveyResponse' && !this.mappings.find(m => m.object_type.model === i.model)
      );
    },
  },
  methods: {
    async addNewMapping(objectType: string) {
      try {
        window.GGRC.zenModal.show({
          type: 'SurveyAnswerMapping',
          data: {
            surveyAnswerId: this.surveyAnswerId,
            surveyResponseId: this.surveyResponseId,
            objectType,
            csrf: this.csrf,
          },
        });
      } catch (e) {
        // User closed modal
      }
    },
    openMappings(objectType: object) {
      try {
        window.GGRC.zenModal.show({
          type: 'SurveyAnswerMapping',
          data: {
            surveyAnswerId: this.surveyAnswerId,
            surveyResponseId: this.surveyResponseId,
            objectType,
            csrf: this.csrf,
          },
        });
      } catch (e) {
        // User closed modal
      }
    },
  },
});
